import * as types from './mutation-types'

export default {

  [types.ADD_ADVICES](state, advices) {
    state.advices = advices.data
    state.meta_data = advices.meta
  }
}
